<template>
  <section class="hero">
    <div class="hero-content">
      <h1>Design System</h1>
      <p>Cette page présente les composants de l'application pour référence.</p>
    </div>
  </section>
  <HeroSlanted title="Titre hero slanted" subtitle="slogan" id="contact" />
  <HeroSlanted title="Titre hero slanted REVERSE" subtitle="reverse reverse reverse... ta compris
    quoi :D" id="contact"
    splitTop="var(--color-grey-light)"
    splitBottom="var(--bg-primary)" reverse />
  <div class="page-container">
    <section class="page-header">
      <h1 class="page-title">Design System h1</h1>
      <p>Composants réutilisables de l'application</p>
    </section>
    <section class="page-header center">
      <h1>Titre centré h1</h1>
    </section>
    <section class="page-content">
      <article>
        <img src="https://placehold.co/600x400" alt="Image d'exemple" />
        <div class="text">
          <h2>Titre de niveau 2 h2</h2>
          <p>Paragraphe d'exemple pour démontrer le style de texte dans le design system. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis non arcu quis eros bibendum tempor. Suspendisse tincidunt risus eu turpis dictum, eget accumsan ligula laoreet. Nullam at massa odio. Sed sed ligula vel ante aliquet laoreet non nec sem. Etiam hendrerit turpis sit amet massa rhoncus, in porta urna pretium. Nullam volutpat arcu lacinia mauris euismod tempor. Mauris rutrum nec turpis vitae volutpat. Quisque quis augue venenatis, ultricies enim ac, finibus lectus. In feugiat, tellus id lacinia cursus, nibh velit luctus lorem, ornare vehicula nisl urna sit amet mauris. Mauris est lectus, facilisis auctor mauris ut, aliquet facilisis sapien. In vehicula purus rutrum magna iaculis, non facilisis quam aliquet. Phasellus vel dictum orci, quis vestibulum dui. Mauris viverra velit ut odio malesuada tristique. Cras nec dolor vitae ligula imperdiet imperdiet at vitae quam.</p>
        </div>
      </article>
      <article>
        <img src="https://placehold.co/600x400" alt="Image d'exemple" />
        <div class="text">
          <h2>Titre de niveau 2 h2</h2>
          <p>Paragraphe d'exemple pour démontrer le style de texte dans le design system. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis non arcu quis eros bibendum tempor. Suspendisse tincidunt risus eu turpis dictum, eget accumsan ligula laoreet. Nullam at massa odio. Sed sed ligula vel ante aliquet laoreet non nec sem. Etiam hendrerit turpis sit amet massa rhoncus, in porta urna pretium. Nullam volutpat arcu lacinia mauris euismod tempor. Mauris rutrum nec turpis vitae volutpat. Quisque quis augue venenatis, ultricies enim ac, finibus lectus. In feugiat, tellus id lacinia cursus, nibh velit luctus lorem, ornare vehicula nisl urna sit amet mauris. Mauris est lectus, facilisis auctor mauris ut, aliquet facilisis sapien. In vehicula purus rutrum magna iaculis, non facilisis quam aliquet. Phasellus vel dictum orci, quis vestibulum dui. Mauris viverra velit ut odio malesuada tristique. Cras nec dolor vitae ligula imperdiet imperdiet at vitae quam.</p>
        </div>
      </article>
      <div class="btn-group">
        <a href="#"><img class="btn-download-app"
          src="https://placehold.co/150x50?text=App+Store" alt="App Store Button" /></a>
        <a href="#"><img class="btn-download-app"
          src="https://placehold.co/150x50?text=Google+Play" alt="Google Play Button"
        /></a>
      </div>
      <div class="contact-container">
        <div class="card">
          <h3>Carte d'exemple</h3>
          <p>Cette carte illustre le style des cartes dans le design system. Elle comprend une bordure, une ombre portée et des effets au survol pour améliorer l'interactivité.</p>
          <form class="form-group">
            <label for="example-input">Exemple de champ de formulaire :</label>
            <input type="text" id="example-input" name="example-input" placeholder="Entrez du texte ici" />
            <label for="example-input">Exemple de champ de formulaire :</label>
            <select>
              <option value="">Sélectionnez une option</option>
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
            </select>
            <label for="example-input">Exemple de champ de formulaire :</label>
            <textarea placeholder="Votre message ici"></textarea>
            <div class="btn-group">
              <button type="submit" class="btn btn-primary btn-full">Bouton principal plein</button>
            </div>
          </form>
        </div>
      </div>
      <h2>Exemples de boutons</h2>
      <div class="btn-group">
        <button @click="openSimpleModal" type="button" class="btn btn-danger">Une simple
          modale</button>
        <button class="btn" @click="openConfirmModal">Confirmer action</button>
        <button class="btn btn-primary" @click="openLoadingModal">Modale de chargement...</button>
        <button class="btn btn-secondary" @click="openFormModal">Modale formulaire</button>
        <button class="btn btn-warning">Bouton d'avertissement</button>
        <button class="btn btn-success">Button success</button>
        <button class="btn btn-danger-secondary">Button danger</button>
      </div>
      <h2>Search Box Component</h2>
      <SearchBox />
      <div class="results-container">
        <TripList
          v-if="!noResults"
          :trips="store.trips"
          :date="store.searchParams.dateToStart"
        />
        <EmptyState
          :is-empty="true"
          emptyMessage="Aucun trajet disponible pour cette date."
        />
        <EmptyState
          variant="ticketValidated"
        />
        <EmptyState
          :error="'Le serveur a renvoyé une erreur 500. Merci de réessayer plus tard.'"
        />
        <EmptyState
          :isUnauthorized="true"
        />
      </div>
      <h2>Tableau des informations</h2>

      <table class="table-primary">
        <tbody>
          <tr>
            <th colspan="2" class="section-header-left">📍 Départ</th>
          </tr>
          <tr>
            <th>Adresse</th>
            <td>
              123 Rue de l'Exemple, Ville, Pays
            </td>
          </tr>
          <tr>
            <th>Heure</th>
            <td>20:30</td>
          </tr>
          <!--
<tr>
<th colspan="2" class="section-header-left">🎟️ Passagers</th>
</tr>
<tr
v-for="(p, index) in passengers"
:key="index"
:class="{ 'is-first-passenger': index === 0 }"
>
<th>#{{ index + 1 }}</th>
<td class="passenger-row">
<select v-model="p.class">
<option value="Classic">Classic</option>
<option value="VIP">VIP</option>
</select>
<select v-model="p.type">
<option value="Adult">Adulte</option>
<option value="Child">Enfant</option>
</select>
<div class="bags">
<button @click="p.bags = Math.max(0, p.bags - 1)" class="btn">-</button>
<span>{{ p.bags }}</span>
<button @click="p.bags++" class="btn">+</button>
</div>
<div class="spacer"></div>
<button
class="btn btn-primary"
v-if="index === passengers.length - 1"
@click="addNewPassenger"
>
+
</button>
<button
class="btn btn-danger"
@click="removePassenger(index)"
v-if="passengers.length > 1"
>
✕
</button>
</td>
</tr>
-->
          <tr>
            <th colspan="2" class="section-header-left">💳 Paiement</th>
          </tr>
          <tr>
            <th>Moyen de paiement</th>
            <td>
              <div class="btn-group">
                <select v-model="paymentMethod">
                  <option value="cm.mtn">MTN</option>
                  <option value="cm.orange">Orange</option>
                  <option value="eumm">EU Mobile</option>
                  <option value="cm.yoomee">Yoomee</option>
                </select>
                <input
                  type="text"
                  v-model="phone"
                  placeholder="Numéro de téléphone"
                  :disabled="paymentMethod === ''"
                  :class="{ hidden: paymentMethod === '' }"
                />
              </div>
            </td>
          </tr>
          <tr>
            <th colspan="2" class="section-header-left price-header">💰 Prix</th>
          </tr>
          <tr>
            <th>Total</th>
            <td class="price-value">
              <strong>{{ totalPrice }} €</strong>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="validation-code">Code de validation du ticket</p>
      <div class="cequetuveux">
        <h1>Formulaire de connexion</h1>
        <form class="form-group">
          <label for="email">Adresse e-mail</label>
          <input type="email" id="email" name="email" placeholder="Entrez votre e-mail" />
          <PasswordField ref="passwordFieldRef" />
          <div class="btn-group">
            <button type="submit" class="btn btn-primary">Se connecter</button>
          </div>
        </form>
      </div>
      <h2>Les Badges</h2>
      <div class="btn-group">
        <span class="badge badge-info">Les filtres actifs</span>
        <span class="badge badge-pending-payment">En attente de paiement</span>
        <span class="badge badge-paid">Payé</span>
        <span class="badge badge-validated">Validé</span>
        <span class="badge badge-cancelled">Annulé</span>
        <span class="badge badge-refunded">Remboursé</span>
        <span class="badge badge-used">Utilisé</span>
      </div>
      <InfoBox type="info">
        <p>Ceci est une information importante</p>
      </InfoBox>

      <InfoBox type="success">
        <p>Opération réussie !</p>
      </InfoBox>

      <InfoBox type="warning">
        <p>Attention, vérifiez vos données</p>
      </InfoBox>

      <InfoBox type="error">
        <p>Une erreur s'est produite</p>
      </InfoBox>

      <InfoBox type="info" :closable="false">
        <p>Message non fermable</p>
      </InfoBox>

      <InfoBox @close="handleClose">
        <p>Message avec événement</p>
      </InfoBox>
      <h2>La zone de filtre</h2>
      <section class="filters form-group">
        <div class="btn-group">
          <div>
            <button class="btn btn-chip is-active">Tous</button>
            <button class="btn btn-chip">Validés</button>
            <button class="btn btn-chip">Non validés</button>
            <button class="btn btn-chip">Non validés</button>
          </div>
          <div>
            <button class="btn btn-secondary">
              Réinitialiser
            </button>
          </div>
        </div>
        <div class="btn-group">
          <div>
            <label for="status-filter">Status</label>
            <select
              id="status-filter"
              class="input input--sm"
            >
              <option value="">Tous</option>
              <option value="pending_payment">En attente</option>
              <option value="paid">Payé</option>
              <option value="used">Utilisé</option>
              <option value="validated">Validé</option>
              <option value="cancelled">Annulé</option>
              <option value="refunded">Remboursé</option>
            </select>
          </div>
          <div>
            <label for="date-from">Du</label>
            <input
              id="date-from"
              type="date"
              class="input input--sm"
            />
          </div>
          <div>
            <label for="date-to">Au</label>
            <input
              id="date-to"
              type="date"
              class="input input--sm"
            />
          </div>
        </div>
      </section>
      <h2>Listing</h2>
      <section class="listing" role="table" aria-colcount="3">
        <div class="listing__body" role="rowgroup">
          <div
            class="listing__row is-validated"
            role="row"
            tabindex="0"
          >
            <div class="listing__cell listing__cell--status" role="cell">
              <span class="badge badge-validated">Validé</span>
            </div>
            <div class="listing__cell listing__cell--date listing__cell--shrink" role="cell">
              <div class="trip-time">
                24/02/2024 à 14:30
              </div>
            </div>
            <div class="listing__cell listing__cell--route" role="cell">
              <div class="route">
                <strong>Nantes → Bordeaux</strong>
              </div>
            </div>
          </div>
          <div
            class="listing__row"
            role="row"
            tabindex="0"
          >
            <div class="listing__cell listing__cell--status" role="cell">
              <span class="badge badge-paid">Payé</span>
            </div>
            <div class="listing__cell listing__cell--date listing__cell--shrink" role="cell">
              <div class="trip-time">
                15/03/2024 à 09:00
              </div>
            </div>
            <div class="listing__cell listing__cell--route" role="cell">
              <div class="route">
                <strong>Bordeaux → Nantes</strong>
              </div>
            </div>
          </div>
        </div>
      </section>
      <h2>Listing détails</h2>
        <div class="card card-details">
          <div class="card-content">
            <div class="card-item">Ligne 1</div>
            <div class="card-item">Ligne 2</div>
            <div class="card-item">Ligne 3</div>
          </div>
        </div>
      <h2>Navigation par onglets</h2>
      <nav class="tabs-nav">
        <a href="#" class="tabs-nav__link is-active">
          <span class="icon">👤</span>
          Profil
        </a>
        <a href="#" class="tabs-nav__link">
          <span class="icon">🎫</span>
          Mes eTickets
        </a>
      </nav>
        <h2>En vrac</h2>
      <div class="cequetuveuxenvrac">
        <button
          type="button"
          class="toggle"
          @click="toggle = !toggle"
        >
          <span class="toggle-icon">
            <!-- LUNE -->
            <svg
              v-if="toggle"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
            <!-- SOLEIL -->
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="5"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
          </span>
          <span
            class="toggle-track"
            :class="{ 'is-active': toggle }"
          >
            <span
              class="toggle-thumb"
              :class="{ 'is-active': toggle }"
            ></span>
          </span>
        </button>
        <a href="#" @click.prevent="launchNotifications">Un lien hypertexte voir les
          notifications</a>
      </div>
    </section>
  </div>
</template>

<script setup>
import HeroSlanted from '@/components/HeroSlanted.vue'
import SearchBox from '@/components/SearchBox.vue'
import TripList from '@/components/TripList.vue'
import EmptyState from '@/components/EmptyState.vue'
import PasswordField from '@/components/PasswordField.vue'
import { reactive, computed, ref, watch } from 'vue'
import { useModalStore } from '@/stores/modalStore'
import { useToast } from 'vue-toast-notification'
import FormFieldsVehicle from '@/components/FormFields/FormFieldsVehicle.vue'
import InfoBox from '@/components/InfoBox.vue'

const paymentMethod = ref('')
const phone = ref('')
const toggle = ref(false)
const totalPrice = computed(() => {
  const basePrice = 29
  return basePrice * passengers.value.length
})
const passengers = ref([{ class: 'Classic', type: 'Adult', bags: 0 }])
const toast = useToast()
const modalStore = useModalStore()
const showForm = ref(false)
const error = null
const noResults = computed(() => store.trips.length === 0)
const store = reactive({
  searchParams: {
    dateToStart: '2025-01-01T00:00:00Z'
  },
  trips: [
    {
      uuid: 'trip-001',
      addressToStart: { city: { name: 'Paris' } },
      addressToEnd: { city: { name: 'Lyon' } },
      timeToStart: '2025-01-01T08:30:00Z',
      timeToEnd: '2025-01-01T10:30:00Z',
      company: { name: 'GreenBus' },
      availablePlaces: 3,
      price: 29,
      vehicle: {
        airConditioning: true,
        wifi: false,
      }
    },
    {
      uuid: 'trip-002',
      addressToStart: { city: { name: 'Lyon' } },
      addressToEnd: { city: { name: 'Marseille' } },
      timeToStart: '2025-01-01T10:00:00Z',
      timeToEnd: '2025-01-01T13:00:00Z',
      company: { name: 'SunTrip' },
      availablePlaces: 2,
      price: 39,
      vehicle: {
        airConditioning: true,
        wifi: false,
      }
    },
    {
      uuid: 'trip-003',
      addressToStart: { city: { name: 'Nice' } },
      addressToEnd: { city: { name: 'Paris' } },
      timeToStart: '2025-01-01T14:45:00Z',
      timeToEnd: '2025-01-01T18:30:00Z',
      company: { name: 'OceanRide' },
      availablePlaces: 4,
      price: 49,
      vehicle: {
        airConditioning: true,
        wifi: false,
      }
    }
  ]
})

const openSimpleModal = async () => {
  const { result } = modalStore.alert(
    'Information importante',
    'Ceci est un exemple de modale simple avec un message informatif.'
  )
  const res = await result
  console.log('Modale fermée:', res)
}

const openLoadingModal = () => {
  const loadingModal = modalStore.loading('Chargement en cours...', 'Veuillez patienter, traitement en cours.')
}

const openFormModal = async () => {
  const { result } = modalStore.openComponent(
    FormFieldsVehicle,
    {
      formData: {
        model: 'Renault Trafic',
        noImmat: 'AB-123-CD',
        nbPlaces: 8,
      }
    },
    {
      title: 'Modifier le véhiculeeeeeee',
      dismissible: true,
      maxWidth: '600px',
      kind: 'form'
    },
  )

  const res = await result
  if (res.action === 'submit') {
    console.log('Données du formulaire:', res.data)
    toast.success(`Véhicule ${res.data.model} enregistré !`)
  } else {
    toast.info('Modification annulée')
  }
}

const openConfirmModal = async () => {
  const { result } = modalStore.confirmDialog(
    'Supprimer le véhicule',
    'Êtes-vous sûr de vouloir supprimer ce véhicule ? Cette action est irréversible.',
    async () => {
      await new Promise(resolve => setTimeout(resolve, 1500))
      toast.success('Véhicule supprimé')
    }
  )

  const res = await result
  console.log('Résultat confirmation:', res)
}

const launchNotifications = () => {
  toast.success('Opération réussie !')
  toast.error('Une erreur est survenue.')
  toast.info('Voici une information importante.')
  toast.warning('Attention, vérifiez vos données.')
}

watch(paymentMethod, (newVal) => {
  if (newVal === '') {
    phone.value = ''
  }
})

function addNewPassenger() {
  if (passengers.value.length >= 5) {
    toast.error('Nombre maximum de passagers atteint pour ce trajet.')
    return
  }
  passengers.value.push({
    class: 'Classic',
    type: 'Adult',
    bags: 0
  })
}

function removePassenger(index) {
  if (passengers.value.length > 1) {
    passengers.value.splice(index, 1)
  }
}
</script>
<style scoped>
.page-content {
  margin: 2rem 0;
  padding-bottom: 6rem;
}
.cequetuveux {
  width: 100%;
  margin: 0 auto;
}
.cequetuveux form {
  background-color: var(--bg-primary);
  max-width: 400px;
}
.cequetuveuxenvrac {
  display: flex;
  flex-flow: row nowrap;
  gap: 1.5rem;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}
.cequetuveuxenvrac h2 {
  margin-bottom: 2rem;
}
.results-container {
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 5rem;
  align-items: center;
}
</style>
